import './underwriting.submission.detail.risk-profile.evidence-notes-modal.scss';

import { Box, Chip, Stack, Typography } from '@mui/material';
import {
  DialogLayout,
  FormContainer,
  NewConvergeButton,
  PrimaryTitle,
} from '../../../presentation/components';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import {
  SubmissionApplicationQuestionDetailsExt,
  SubmissionQuestionDetails,
} from '../../application';

import { ConvergeNotes } from '../../notes';
import { NoteTargetAreaType } from '@converge/graphql';
import RiskProfileApplicationQuestionSwitcher from '../../application/question/risk-profile-question-switcher';
import { displayNumber } from '@converge/utils';

interface IProps {
  header: string;
  coverageScore: number;
  subHeader: string;
  subControlScore: number;
  show: boolean;
  submissionUuid: string;
  subControlUuid: string;
  onClose: () => void;
  questions:
    | SubmissionApplicationQuestionDetailsExt[]
    | SubmissionQuestionDetails[];
}

export const UnderwritingSubmissionDetailRiskProfileEvidenceNotesModal = ({
  header,
  coverageScore,
  subHeader,
  subControlScore,
  subControlUuid,
  show,
  onClose,
  questions,
  submissionUuid,
}: IProps) => {
  const formMethods = useForm();

  formMethods.register('notes');

  const onSubmitHandler = async (values: FieldValues) => {
    onClose();
  };

  return (
    <FormProvider {...formMethods}>
      <DialogLayout
        open={show}
        maxWidth="md"
        isSubControl
        header={
          <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '12px',
                marginTop: '60px',
              }}
            >
              <PrimaryTitle
                style={{ marginLeft: '12px', width: '745px' }}
                variant="h4"
              >
                {header}
              </PrimaryTitle>
              <Chip label={displayNumber(coverageScore) || ''}></Chip>
            </div>{' '}
          </>
        }
        body={
          <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <PrimaryTitle
                variant="h5"
                style={{ marginLeft: '12px', width: '745px' }}
              >
                {subHeader}
              </PrimaryTitle>
              <Chip
                style={{ marginRight: '58px' }}
                label={displayNumber(subControlScore) || ''}
              ></Chip>
            </div>
            <br />
            <div className="evidence-notes-body-content">
              <Typography fontWeight="bold" className="questionnaire-title">
                {questions?.length
                  ? 'Questionnaire answers'
                  : 'Derived from third party data'}
              </Typography>
              <div className="evidence-notes-questions">
                <FormContainer>
                  {questions?.map((question) => (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',

                        borderBottom: '1px solid #ccc',
                        width: '90%',
                        padding: '26px 22px 30px 64px',
                        paddingTop: '32px',
                      }}
                    >
                      <RiskProfileApplicationQuestionSwitcher
                        key={question.uuid}
                        question={question as SubmissionQuestionDetails}
                        isApplicationViewOnly={true}
                      />
                    </div>
                  ))}
                </FormContainer>
              </div>
              <br />

              <div className="evidence-notes-editor">
                <Stack marginTop={2} padding={1} flexGrow={1}>
                  <ConvergeNotes
                    title="Notes"
                    hideHeader
                    targetUuid={subControlUuid}
                    targetArea={NoteTargetAreaType.SubControl}
                    targetSubUuid={submissionUuid}
                  />
                </Stack>
              </div>
            </div>
          </>
        }
        footer={
          <Box style={{ margin: '0px 10px 10px 0px' }}>
            <NewConvergeButton
              label="Save"
              onClick={formMethods.handleSubmit(onSubmitHandler)}
            />
          </Box>
        }
        showCloseButton
        onCloseIconClick={onClose}
        onClose={onClose}
      />
    </FormProvider>
  );
};
